// @ts-strict-ignore
import buildDependencies from '../dependencies';
import {
  transformBooleanRuleAndDataRoutesInActions,
  transformLegacyActionsToJsonRepresentation,
} from './actions';
import { transformLegacyThresholdsToJsonRepresentation } from './thresholds';
import { transformLegacyDataRoutesToJsonRepresentation } from './dataRoutes/dataRoutes';
import type { Services, ServicesByName } from '../types';

export function transformLegacyRepresentationToJson({
  actions,
  actionOptions,
  thresholds,
  dataRoutes,
  tags,
  services,
  outcomes,
  publishedAttributes,
  matrixModels,
  lists,
  reasonCodeGroups,
  customLists,
  snippets,
}) {
  const {
    transformedActionsWithoutRules,
    legacyActionsTransformationMap,
    issuesWithTransformedJsonActions,
  } = transformLegacyActionsToJsonRepresentation({
    actions,
    actionOptions,
    tags,
    services,
    outcomes,
    publishedAttributes,
    matrixModels,
    lists,
    customLists,
    snippets,
  });
  const {
    transformedThresholds,
    legacyThresholdsTransformationMap,
    issuesWithTransformedJsonThresholds,
  } = transformLegacyThresholdsToJsonRepresentation({
    thresholds,
    transformedActions: transformedActionsWithoutRules,
    services,
    legacyActionsToTransformedActionsIdMap: legacyActionsTransformationMap.relativeIds,
    reasonCodeGroups,
  });
  const {
    transformedDataRoutes,
    legacyDataRoutesTransformationMap,
  } = transformLegacyDataRoutesToJsonRepresentation({
    dataRoutes,
    transformedActions: transformedActionsWithoutRules,
    services,
    legacyActionsToTransformedActionsIdMap: legacyActionsTransformationMap.relativeIds,
  });
  const transformedActionsWithRules = transformBooleanRuleAndDataRoutesInActions({
    transformedActionsWithoutRules,
    legacyToTransformedThresholdIdMap: legacyThresholdsTransformationMap,
    legacyDataRoutesToTransformedDataRoutesIdMap: legacyDataRoutesTransformationMap,
  });


  const dependencies = buildDependencies({
    actions: transformedActionsWithRules,
    dataRoutes: transformedDataRoutes,
    thresholds: transformedThresholds,
  });

  const validations = {
    timestamp: Date.now(),
    actions: issuesWithTransformedJsonActions,
    thresholds: issuesWithTransformedJsonThresholds,
  };

  return {
    actions: transformedActionsWithRules,
    thresholds: transformedThresholds,
    dataRoutes: transformedDataRoutes,
    dependencies,
    validations,
    legacyMappings: {
      actions: legacyActionsTransformationMap.absoluteIds,
      thresholds: legacyThresholdsTransformationMap,
    },
  };
}

export function keyServicesObjectByInternalName(services: Services): ServicesByName {
  return Object.entries(services).reduce((newServices, [, serviceObj]) => ({
    ...newServices, [serviceObj.internal_name]: serviceObj,
  }), {});
}
